import React, { useEffect } from "react";
import "@/App.css";
import Lenis from "lenis";
import { Toaster } from "sonner";
import { BrowserRouter, Routes, Route, useLocation, useNavigate } from "react-router-dom";
import { Nav } from "@/components/site/Nav";
import { Hero } from "@/components/site/Hero";
import { USP } from "@/components/site/USP";
import { Over } from "@/components/site/Over";
import { Aanbod } from "@/components/site/Aanbod";
import { Werkwijze } from "@/components/site/Werkwijze";
import { Reviews } from "@/components/site/Reviews";
import { ContactCTA } from "@/components/site/ContactCTA";
import { Footer } from "@/components/site/Footer";
import { Faq } from "@/components/site/Faq";
import { LegalPage } from "@/components/site/LegalPage";
import { CookieBanner } from "@/components/site/CookieBanner";
import { PRIVACY, COOKIES, TERMS } from "@/data/legal";
import { scrollToId } from "@/data/site";

const Home = () => (
  <main>
    <Hero />
    <USP />
    <Over />
    <Aanbod />
    <Werkwijze />
    <Reviews />
    <ContactCTA />
  </main>
);

const Shell = () => {
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    window.__navigate = navigate;
    return () => {
      window.__navigate = null;
    };
  }, [navigate]);

  useEffect(() => {
    const onClick = (e) => {
      const a = e.target.closest('a[href^="#"]');
      if (!a) return;
      const href = a.getAttribute("href");
      if (href && href.length > 1) {
        e.preventDefault();
        scrollToId(href);
      }
    };
    document.addEventListener("click", onClick);
    return () => document.removeEventListener("click", onClick);
  }, []);

  useEffect(() => {
    if (location.pathname === "/" && location.hash) {
      const t = setTimeout(() => scrollToId(location.hash), 300);
      return () => clearTimeout(t);
    }
    if (window.__lenis) {
      window.__lenis.scrollTo(0, { immediate: true });
    } else {
      window.scrollTo(0, 0);
    }
  }, [location.pathname, location.hash]);

  return (
    <div className="App" data-testid="app-root">
      <Nav />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/faq" element={<Faq />} />
        <Route path="/privacy" element={<LegalPage {...PRIVACY} />} />
        <Route path="/cookiebeleid" element={<LegalPage {...COOKIES} />} />
        <Route path="/algemene-voorwaarden" element={<LegalPage {...TERMS} />} />
      </Routes>
      <Footer />
      <CookieBanner />
      <Toaster position="top-center" richColors />
    </div>
  );
};

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    window.__lenis = lenis;
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
      window.__lenis = null;
    };
  }, []);

  return (
    <BrowserRouter>
      <Shell />
    </BrowserRouter>
  );
}

export default App;
